const prefix = 'INVENTORY_TRANSFER';

export const INVENTORY_TRANSFER_RESET_STATE = `${prefix}_RESET_STATE`;
export const INVENTORY_TRANSFER_PAGE_REQUEST = `${prefix}_PAGE_REQUEST`;
export const INVENTORY_TRANSFER_SET_TRANSFERS = `${prefix}_SET_TRANSFERS`;
export const INVENTORY_TRANSFER_SET_TRANSFER_DETAIL = `${prefix}_SET_TRANSFER_DETAIL`;
export const INVENTORY_TRANSFER_SET_OUTLETS = `${prefix}_SET_OUTLETS`;
export const INVENTORY_TRANSFER_SET_ALL_OUTLETS = `${prefix}_SET_ALL_OUTLETS`;
export const INVENTORY_TRANSFER_SET_VALID_OUTLETS = `${prefix}_SET_VALID_OUTLETS`;
export const INVENTORY_TRANSFER_SET_SELECTED_OUTLET_FROM_NAME = `${prefix}_SET_SELECTED_OUTLET_FROM_NAME`;
export const INVENTORY_TRANSFER_SET_SELECTED_OUTLETS = `${prefix}_SET_SELECTED_OUTLETS`;
export const INVENTORY_TRANSFER_TRANSFERS_REQUEST = `${prefix}_TRANSFERS_REQUEST`;
export const INVENTORY_TRANSFER_SET_CURRENT_PAGE = `${prefix}_SET_CURRENT_PAGE`;
export const INVENTORY_TRANSFER_SET_TOTAL_PAGE = `${prefix}_SET_TOTAL_PAGE`;
export const INVENTORY_TRANSFER_ON_CLICK_ROW = `${prefix}_ON_CLICK_ROW`;
export const INVENTORY_TRANSFER_OPEN_RIGHT_COLUMN = `${prefix}_OPEN_RIGHT_COLUMN`;
export const INVENTORY_TRANSFER_CLOSE_RIGHT_COLUMN = `${prefix}_CLOSE_RIGHT_COLUMN`;
export const INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS = `${prefix}_ON_CHANGE_OUTLET_IDS`;
export const INVENTORY_TRANSFER_ON_CHANGE_DATE = `${prefix}_ON_CHANGE_DATE`;
export const INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER = `${prefix}_ON_CLICK_CREATE_TRANSFER`;
export const INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM = `${prefix}_ON_CLICK_ADD_ITEM`;
export const INVENTORY_TRANSFER_CLOSE_ADD_ITEM_MODAL = `${prefix}_CLOSE_ADD_ITEM_MODAL`;
export const INVENTORY_TRANSFER_ON_MODAL_CLICK_CANCEL = `${prefix}_ON_MODAL_CLICK_CANCEL`;
export const INVENTORY_TRANSFER_GET_ITEMS = `${prefix}_GET_ITEMS`;
export const INVENTORY_TRANSFER_SET_ADD_ITEMS = `${prefix}_SET_ADD_ITEMS`;
export const INVENTORY_TRANSFER_RESET_ADD_ITEMS = `${prefix}_RESET_ADD_ITEMS`;
export const INVENTORY_TRANSFER_SET_ITEMS_OPTION_IS_LOADING = `${prefix}_SET_ITEMS_OPTION_IS_LOADING`;
export const INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE = `${prefix}_ON_MODAL_SELECT_CHANGE`;
export const INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM = `${prefix}_ON_MODAL_ADD_ITEM`;
export const INVENTORY_TRANSFER_RESET_TRANSFERS_FORM = `${prefix}_RESET_TRANSFERS_FORM`;
export const INVENTORY_TRANSFER_SET_SHOW_CONFRIM_SUBMIT_MODAL = `${prefix}_SET_SHOW_CONFRIM_SUBMIT_MODAL`;
export const INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM = `${prefix}_ON_SUBMIT_CREATE_TRANSFER_FORM`;
export const INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER = `${prefix}_ON_CONFIRM_CREATE_TRANSFER`;
export const INVENTORY_TRANSFER_EXPORT = `${prefix}_EXPORT`;
export const INVENTORY_TRANSFER_SET_EXPORT_BUTTON_STATUS = `${prefix}_SET_EXPORT_BUTTON_STATUS`;
export const INVENTORY_TRANSFER_SET_IS_ITEM_ALREADY_ADDED = `${prefix}_SET_IS_ITEM_ALREADY_ADDED`;
export const INVENTORY_TRANSFER_SET_CONFIRM_CREATE_BUTTON_STATUS = `${prefix}_SET_CONFIRM_CREATE_BUTTON_STATUS`;
export const INVENTORY_TRANSFER_SET_SEARCH_ITEMS_INIT = `${prefix}_SET_SEARCH_ITEMS_INIT`;

export const INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE = `${prefix}_ON_NAMESPACE_CHANGE`;

export const INVENTORY_TRANSFER_EXPORT_START = `${prefix}_IS_START_EXPORTING`;
export const INVENTORY_TRANSFER_EXPORT_DONE = `${prefix}_IS_DONE_EXPORTING`;
export const INVENTORY_TRANSFER_EXPORT_FAILED = `${prefix}_IS_FAILED_EXPORTING`;
export const INVENTORY_TRANSFER_SET_ASYNCJOBID = `${prefix}_SET_ASYNCJOBID`;

// Advanced Inventory Feature Constants
export const INVENTORY_TRANSFER_GET_INVENTORY_SETTINGS = `${prefix}_GET_INVENTORY_SETTINGS`;
export const INVENTORY_TRANSFER_DELETE = `${prefix}_DELETE`;
export const INVENTORY_TRANSFER_SET_TRANSFER_TYPE = `${prefix}_SET_TRANSFER_TYPE`;
export const INVENTORY_TRANSFER_SET_FORM_TYPE = `${prefix}_SET_FORM_TYPE`;
export const INVENTORY_TRANSFER_SET_TRANSFER_ACTIVITIES = `${prefix}_SET_TRANSFER_ACTIVITIES`;
export const ADVANCED_INVENTORY_TRANSFER_ON_CLICK_ROW =
  'ADVANCE_INVENTORY_TRANSFER_ON_CLICK_ROW';
export const INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS =
  'INVENTORY_ADVANCED_TRANSFER_SET_TRANSFERS';
export const INVENTORY_ADVANCED_TRANSFER_ALL_TAB_REQUEST =
  'INVENTORY_ADVANCED_TRANSFER_ALL_TAB_REQUEST';
export const INVENTORY_ADVANCED_TRANSFER_TAB_REQUEST =
  'INVENTORY_ADVANCED_TRANSFER_TAB_REQUEST';
export const INVENTORY_ADVANCED_TRANSFER_REQUEST_EDIT =
  'INVENTORY_ADVANCED_TRANSFER_REQUEST_EDIT';
export const INVENTORY_ADVANCED_TRANSFER_EDIT =
  'INVENTORY_ADVANCED_TRANSFER_EDIT';
export const INVENTORY_ADVANCE_TRANSFER_CLOSE_FORM_DETAIL =
  'INVENTORY_ADVANCE_TRANSFER_CLOSE_FORM_DETAIL';
export const INVENTORY_TRANSFER_ON_CONFIRM_ADVANCED_CREATE_TRANSFER = `${prefix}_ON_CONFIRM_ADVANCED_CREATE_TRANSFER`;
export const ADVANCE_INVENTORY_TRANSFER_ON_SUBMIT_APPROVE_REQUEST =
  'ADVANCE_INVENTORY_TRANSFER_ON_SUBMIT_APPROVE_REQUEST';
export const ADVANCE_INVENTORY_TRANSFER_SUBMIT_APPROVAL_FORM =
  'ADVANCE_INVENTORY_TRANSFER_SUBMIT_APPROVAL_FORM';
export const ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER =
  'ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_ITEM_TRANSFER';
export const ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER =
  'ADVANCE_INVENTORY_TRANSFER_SET_DETAIL_INGREDIENT_TRANSFER';
export const ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER =
  'ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_ITEM_TRANSFER';
export const ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER =
  'ADVANCE_INVENTORY_TRANSFER_SET_PARTIAL_INGREDIENT_TRANSFER';
export const INVENTORY_TRANSFER_ERROR_ITEM = 'INVENTORY_TRANSFER_ERROR_ITEM';
export const ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION =
  'ADVANCE_INVENTORY_TRANSFER_TAB_PERMISSION';
export const INVENTORY_ADVANCE_TRANSFER_SUBMIT_SHIPMENT =
  'INVENTORY_ADVANCE_TRANSFER_SUBMIT_SHIPMENT';
export const INVENTORY_ADVANCE_TRANSFER_SUBMIT_FULFILLMENT =
  'INVENTORY_ADVANCE_TRANSFER_SUBMIT_FULFILLMENT';
export const INVENTORY_ADVANCE_TRANSFER_FETCH_NEXT_PAGE =
  'INVENTORY_ADVANCE_TRANSFER_FETCH_NEXT_PAGE';
